<template>
  <nav>
    <div
      class="fill-height view-mode"
      :class="
        mobileOverride() ? 'activity-page-container-mobile' : 'activity-page-container'
      "
    >
      <AlertMessages
        v-if="alertValue"
        :alert-type="alertType"
        :alert-msg="alertMsg"
        @reset="alertValue = false"
      />
    <!--top right chip draft version tag-->
      <v-row
        v-if="showDraftTag && role == 'booster' && !mobile()"
        no-gutters
        class="text-right custom-draft-tag custom-draft-tag-style-more-right"
      >
        <v-col cols="12">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-chip
                v-if="published"
                data-testid="draft-available-chip"
                color="primary"
                text-color="white"
                v-on="on"
              >
                {{ $t("draftAvailableTag") }}
              </v-chip>
              <v-chip
                v-else
                data-testid="draft-available-chip"
                color="warning"
                text-color="black"
                v-on="on"
              >
                {{ $t("draftAvailableTag") }}
              </v-chip>
            </template>
            <span>{{ $t("draftAvailableTooltip") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <!--END top right chip draft version tag-->
      <!--not booster-->
      <v-row
        v-if="noPublishedItems == true && !loadingData && role != 'booster'"
        class="fill-height"
        align="center"
        data-testid="no-published-content"
      >
        <v-col
          cols="12"
          class="mr-n2"
          :class="!mobile() ? 'px-3' : ''"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px;' : ''"
          align="center"
        >
          <EmptyPage
            :page-title="$t('noPublishedItemsTitle')"
            :page-text="$t('noPublishedItemsText')"
            page-image="image4"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="!loadingData && lockedContent && !noPublishedItems && role != 'booster'"
        class="greyactivitybackground fill-height"
        align="center"
        no-gutters
      >
        <v-col
          cols="12"
          class="fill-height mr-n2"
          :class="!mobile() ? 'px-3' : ''"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px;' : ''"
        >
          <LockedContent
            max-width="960px"
            elevation="0"
            class="fill-height"
            :content="requiredContent"
            :type="lockType"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="pageContent != null && !loadingData && role !='booster'"
        class="greyactivitybackground fill-height"
        no-gutters
      >
        <v-col
          cols="12"
          class="fill-height mr-n2"
          :class="!mobile() ? 'px-3' : ''"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px;' : ''"
        >
          <!-- eslint-disable vue/no-v-html -->
          <div :class="!mobile() ? 'rounded-xxl fill-height' : 'fill-height'">
          <v-card
            ref="viewPage"
            max-width="960px"
            elevation="0"
            :rounded="!mobile() ? 'xxl' : ''"
            class="mx-auto fill-height overflow-hidden"
            :class="mobile() ? 'py-16' : ''"
          >
            <runtime-template-compiler :template="'<div>'+pageContent+'</div>'" />
          </v-card>
          </div>
        </v-col>
      </v-row>

      <!--end not booster-->
      <!--booster-->
      <v-row
        v-if="!loadingData && role =='booster'"
        class="greyactivitybackground fill-height"
        no-gutters
      >
        <v-col
          cols="12"
          class="fill-height"
          :class="!mobile() ? 'px-3' : ''"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px;' : ''"
        >
          <div class="text-center d-none d-md-block">
            <ActivityViewToggle @toggleView="changeView"/>
          </div>
          <v-tabs
            v-model="tabs"
            right
            slider-color="white"
            slider-size="0px"
            :background-color="!mobile() ? 'greyactivitybackground' : ''"
            active-class="tab-version-active"
            class="mx-auto fill-height view-page overflow-hidden"
            :class="screen"
            data-testid="show-tabs"
          >
            <v-tab
              href="#publish"
              style="border-radius: 8px 8px 0 0"
              class="tab-version publish"
              v-if="published"
              v-show="!mobile()"
            >
              {{ $t('published') }}
            </v-tab>
            <v-tab
              href="#draft"
              style="color: #fbc02d; border-radius: 8px 8px 0 0"
              class="tab-version draft"
              v-if="draftVersion == true || (!published && !draftVersion)"
              v-show="!mobile()"
            >
              {{ $t('draft') }}
            </v-tab>

            <v-tabs-items v-model="tabs" :class="mobile() ? 'fill-height' : ''">
              <v-tab-item
                value="publish"
                key="publish"
                :transition="false"
                reverse-transition="false"
                :style="!mobile() ? 'border: 2px solid #F4F5F5;' : ''"
                v-if="published && pageContent != null"
              >
                <!-- eslint-disable vue/no-v-html -->
                <div class="mobile-view-scroll-inside" :class=" this.screen !== 'mobile-view' ? 'rounded-xxl' : ''">
                  <v-card
                    ref="viewPage"
                    elevation="0"
                    class="mx-auto fill-height"
                    :class="{'mobile-view-simulator': screen == 'mobile-view', 'rounded-xxl': !mobile() && this.screen !== 'mobile-view', 'pt-4 pb-16': mobile(), 'overflow-hidden ': screen != 'mobile-view'}"
                  >
                    <runtime-template-compiler
                      :template="'<div>' + pageContent + '</div>'"
                    />
                  </v-card>
                </div>
              </v-tab-item>
              <v-tab-item
                v-else
                value="publish"
                key="publish"
                :transition="false"
                reverse-transition="false"
                class="fill-height"
                :style="!mobile() ? 'border: 2px solid #F4F5F5;' : ''"
              >
                <EmptyPageActivity
                  elevation="0"
                  class="mx-auto fill-height"
                  align="center"
                  :page-title="$t('emptyActivityPageTitle')"
                  :page-text="$t('emptyActivityPageText')"
                  page-image="image4"
                  :class="screen == 'mobile-view' ? 'mobile-view-simulator' : ''"
                />
              </v-tab-item>
              <v-tab-item
                value="draft"
                key="draft"
                :transition="false"
                reverse-transition="false"
                :class="!mobile() && this.screen !== 'mobile-view' ? 'rounded-xxl' : ''"
                :style="!mobile() ? 'border: 2px solid #fbc02d;' : ''"
                v-if="draftVersion == true && pageDraftContent != null"
              >
                <!-- eslint-disable vue/no-v-html -->
                <div class="mobile-view-scroll-inside" :class="this.screen !== 'mobile-view' ? 'rounded-xxl' : ''">
                  <v-card
                    ref="viewPage"
                    elevation="0"
                    class="mx-auto fill-height"
                    :class="{'mobile-view-simulator': screen == 'mobile-view', 'rounded-xxl': !mobile() && this.screen !== 'mobile-view', 'pt-4 pb-16': mobile(), 'overflow-hidden': screen != 'mobile-view'}"

                  >
                    <runtime-template-compiler
                      :template="'<div>'+pageDraftContent +'</div>'"
                    />
                  </v-card>
                </div>
              </v-tab-item>
                <v-tab-item
                v-else
                value="draft"
                key="draft"
                :transition="false"
                reverse-transition="false"
                class="rounded-xxl"
                :style="!mobile() ? 'border: 2px solid #fbc02d;' : ''"
              >
                <EmptyPageActivity               
                  elevation="0"
                  class="mx-auto fill-height"
                  align="center"
                  :page-title="$t('emptyActivityPageTitle')"
                  :page-text="$t('emptyActivityPageText')"
                  page-image="image4"
                  :class="screen == 'mobile-view' ? 'mobile-view-simulator' : ''"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-col>
      </v-row>

      <v-card
        ref="viewNavigationButtons"
        max-width="960px"
        elevation="0"
        class="mx-auto"
        v-if="role != 'booster' && !loadingData"
      >
        <NavigationBackButton
          :activity-pages="activity_pages"
        />
        <NavigationNextButton
          :activity-pages="activity_pages"
        />
      </v-card>
      

      <EditButtonWithLinkInActivity
        v-if="isAuth && role == 'booster' && !loadingData && !mobile()"
        data-testid="edit-activity-page-button"
        rounded="xxl"
        :class="editButtonTextColor"
        :color="editButtonColor"
        :link="{title: '', route: '/activity/'+$route.params.id+'/page/'+$route.params.pageId+'/edit'}"
        :classes="'edit-activity'"
        @openPreventEditingDialog="dialogVisible = true"
      />

      <ConfirmationDialog
        v-if="dialogVisible"
        ref="confirmationDialog"
        :visible="dialogVisible"
        :cd-title="confirmationDialogTitle"
        :cd-text="confirmationDialogText"
        :cd-submit-btn="confirmationDialogSubmitBtn"
        :cd-cancel-btn="confirmationDialogCancelBtn"
        :cd-submit-btn-color="cdSubmitBtnColor"
        data-testid="confirmation-dialog"
        @close="dialogVisible = false"
        @proceedSubmit="dialogVisible = false"
      />

    </div>
  </nav>
</template>

<script>
import i18n from '../../plugins/i18n'
import { getActivity, getActivityPages, getActivityPage,getActivityPageDraft, markActivityPageAsStarted, markActivityPageAsFinished, changeImageInActivityPage, changeDocumentInActivityPage } from '../../api/activityApi'
import {eventBus} from '../../eventbus'
import EmptyPage from '../../components/EmptyPage'
import EmptyPageActivity from '../../components/EmptyPageActivity'
import NavigationNextButton from '../../components/NavigationNextButton'
import EditButtonWithLinkInActivity from '../../components/EditButtonWithLinkInActivity'
import AlertMessages  from '../../components/AlertMessages'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import LockedContent from '../../components/LockedContent'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import { RuntimeTemplateCompiler } from "vue-runtime-template-compiler"
import moment from 'moment'
import NavigationBackButton from '../../components/NavigationBackButton'
import ActivityViewToggle from '../../components/ActivityViewToggle'

export default {
    components: {
        EmptyPage,
        EmptyPageActivity,
        NavigationNextButton,
        EditButtonWithLinkInActivity,
        AlertMessages,
        LockedContent,
        ConfirmationDialog,
        RuntimeTemplateCompiler,
        NavigationBackButton,
        ActivityViewToggle
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            isAuth: window.$cookies.get("token")? true: false,
            checkboxCertificate: false,
            loadingData: false,
            spaceId: window.$cookies.get('space_id'),
            activityId: this.$route.params.id,
            pageId: this.$route.params.pageId,
            quizId: this.$route.params.quizId,
            scormId: this.$route.params.scormId,
            alertMsg: '',
            alertValue:false,
            alertType: '',
            activity_pages: [],
            pageContent: null,
            showDraftTag: false,
            role:'',
            published: false,
            editButtonColor: 'warning',
            editButtonTextColor: 'black--text',
            scrolledToBottom: false,
            noPublishedItems: false,
            lockedContent: false,
            requiredContent: {},
            pageExist: true,
            dialogVisible: false,
            confirmationDialogTitle: i18n.t('confirmationDialogTitlePreventEdit'),
            confirmationDialogText: i18n.t('confirmationDialogTextPreventEdit'),
            confirmationDialogSubmitBtn: i18n.t('ok'),
            confirmationDialogCancelBtn: i18n.t('cancel'),
            cdSubmitBtnColor: 'accent',
            showForum: true,
            tabs: 'publish',
            pageDraftContent:null,
            draftVersion: false,
            draftVersionId: 0,
            listHtml:[],
            lockType: null,
            screen: 'desktop-view'
        }
    },
    async beforeRouteEnter(to, from, next) {
        if(to.params.pageId){   
            //next({ path: '/activity/'+ to.params.id+'/page/'+ to.params.pageId })
        }else{
            try {
                const response = await getActivity(to.params.id);
                if(response.status == 200) {
                    var activityDefaultPageId = response.data.data.attributes.activity_page_id
                    var params = to.params
                    var querys = to.query
                    if (response.data.data.attributes.activity_page_id != null) {
                        if(response.data.data.attributes.top_feed_entity == "page"){
                            params.pageId = activityDefaultPageId
                            next({ name: 'ViewActivityPage', params: params, query:querys })
                        }else if(response.data.data.attributes.top_feed_entity == "quiz"){
                            params.quizId = activityDefaultPageId
                            next({ name: 'ViewActivityQuiz', params: params,  query:querys })
                        }else if(response.data.data.attributes.top_feed_entity == "scorm"){
                            params.scormId = activityDefaultPageId
                            next({ name: 'ViewActivityScorm', params: params,  query:querys })
                        }else if(response.data.data.attributes.top_feed_entity == "checklist"){
                            params.checklistId = activityDefaultPageId
                            next({ name: 'ViewActivityChecklist', params: params,  query:querys })
                        }else if(response.data.data.attributes.top_feed_entity == "survey"){
                            params.surveyId = activityDefaultPageId
                            next({ name: 'ViewActivitySurvey', params: params,  query:querys })
                        }
                    }
                }
            }
            catch (e) {
                if (e.response.status == 401) {
                    console.log("flexible")
                }

            }
        }
        next(vm => {
            vm.getPrevRoute(from);
        })          
    },
    async created(){
         if(this.$route.params.successfullyCreatedActivity){     
            this.alertMsg = i18n.t('createActivitySuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyCreatedActivityPage){     
            this.alertMsg = i18n.t('createActivityPageSuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyCreatedActivityQuiz){     
            this.alertMsg = i18n.t('createActivityQuizSuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyAddedActivityScorm){     
            this.alertMsg = i18n.t('createActivityScormSuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyCreatedActivityChecklist){     
            this.alertMsg = i18n.t('createActivityChecklistSuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyCreatedActivitySurvey){     
            this.alertMsg = i18n.t('createActivitySurveySuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyUpdatedActivityPage){
            this.alertMsg = i18n.t('editActivityPageSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        if(this.$route.params.successfullyUpdatedActivityPageDraft){
            this.alertMsg = i18n.t('editActivityPageDraftSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullySharedActivity){
            this.alertMsg = i18n.t('shareActivitySuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        if(this.$route.params.successfullyDeletedActivityPage){
            this.alertMsg = i18n.t('deleteActivityPageSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        if(this.$route.params.successfullyDeletedActivityQuiz){
            this.alertMsg = i18n.t('deleteActivityQuizSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        if(this.$route.params.successfullyDeletedActivityScorm){
            this.alertMsg = i18n.t('deleteActivityScormSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        if(this.$route.params.successfullyDeletedActivityChecklist){
            this.alertMsg = i18n.t('deleteActivityChecklistSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        if(this.$route.params.successfullyDeletedActivitySurvey){
            this.alertMsg = i18n.t('deleteActivitySurveySuccess')
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyDuplicatedActivityPage){
            this.alertMsg = i18n.t('duplicateActivityPageSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        
        if(this.$route.params.boostersAddedInActivity){
            this.alertMsg = i18n.t('addActivityBoostersSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }

        if (this.$route.params.successfullyConnectedActivityEduAdmin) {
            this.alertMsg = i18n.t("eduAdminConnectedActivitySuccess");
            this.alertType = "success";
            this.alertValue = true;
        }

        if(this.$route.params.preventEditing){
            this.dialogVisible = true
        }

        this.loadingData = true
        this.lockedContent = false
        this.pageId = this.$route.params.pageId

        await this.getActivityPages()
        
        await this.getActivity()

        if (this.role == 'participant' || this.role == 'guest') {
            //reset navigation
            eventBus.$emit('changeNavigationInActivity', this.activity_pages)
        }

        //create element just for manipulating files
        var element = document.createElement('div');
        element.insertAdjacentHTML('beforeend', this.pageContent)
            if(element.querySelectorAll("[path]").length > 0){
            await this.changeTemporaryURLs(element.querySelectorAll("[path]"), element, 'published')
        }
        if(element.querySelectorAll("[pathDoc]").length > 0){
            await this.changeTemporaryURLsDoc(element.querySelectorAll("[pathDoc]"), element, 'published')
        }
        if(element.querySelectorAll("[pathAudio]").length > 0){
            await this.changeTemporaryURLsAudio(element.querySelectorAll("[pathAudio]"), element, 'published')
        }


        var elementDraft = document.createElement('div');
        elementDraft.insertAdjacentHTML('beforeend', this.pageDraftContent)         
        if(elementDraft.querySelectorAll("[path]").length > 0){
            await this.changeTemporaryURLs(elementDraft.querySelectorAll("[path]"), elementDraft, 'draft')
        }
        if(elementDraft.querySelectorAll("[pathDoc]").length > 0){
            await this.changeTemporaryURLsDoc(elementDraft.querySelectorAll("[pathDoc]"), elementDraft,'draft')
        }
        if(elementDraft.querySelectorAll("[pathAudio]").length > 0){
            await this.changeTemporaryURLsAudio(elementDraft.querySelectorAll("[pathAudio]"), elementDraft, 'draft')
        }
        this.loadingData = false

        if ((this.role == 'participant' || this.role == 'guest') && this.noPublishedItems == false) {
            setTimeout(() => {
                this.checkAndMarkIfFinished()
                window.addEventListener('scroll', this.checkAndMarkIfFinished)
            }, 3000)
        }
    },
    destroyed() {
        window.removeEventListener('scroll', this.checkAndMarkIfFinished)
    },

    methods:{
        mobileOverride(){
            if(this.screen == 'mobile-view'){
                return true;
            }else{
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm);
            }
        },
        changeView(val){
            this.screen = val
        },
        async changeTemporaryURLs(nodes, element, status){
            var listNodes = []
            for(var i = 0; i < nodes.length; i++){
                if(listNodes.indexOf(nodes[i].attributes.path.nodeValue) === -1) {
                    listNodes.push(nodes[i].attributes.path.nodeValue);
                }
            }
            try {
                let data = {
                    data: {
                        type: "activity-pages", 
                        id: this.pageId,
                        attributes: {
                            paths: listNodes,
                            space_id: this.spaceId
                        }
                    }
                };
                const response = await changeImageInActivityPage(this.pageId, data)
                 Object.keys(response.data.meta.files).forEach(function(key) {
                    //find and change in html
                    element.querySelectorAll('[path="' + key +'"]').forEach(function(item){
                        item.attributes.src.nodeValue=response.data.meta.files[key]
                    })
                });
                
                if(status == 'published'){
                    this.pageContent = element.innerHTML
                }else{
                    this.pageDraftContent = element.innerHTML
                } 
                
            } catch (e) {
                this.alertValue = true
                this.alertType = 'error';
                this.alertMsg =  i18n.t('serverError');
            }
        },
        async changeTemporaryURLsDoc(nodes, element, status){
            var listNodes = []
            for(var i = 0; i < nodes.length; i++){
                if(listNodes.indexOf(nodes[i].attributes.pathDoc.nodeValue) === -1) {
                    listNodes.push(nodes[i].attributes.pathDoc.nodeValue);
                }
            }
            try {
                let data = {
                    data: {
                        type: "activity-pages", 
                        id: this.pageId,
                        attributes: {
                            paths: listNodes.filter((x, i, a) => a.indexOf(x) == i),
                            space_id: this.spaceId
                        }
                    }
                };
                const response = await changeDocumentInActivityPage(this.pageId, data)
                Object.keys(response.data.meta.files).forEach(function(key) {
                    //find and change in html
                    element.querySelectorAll('[pathDoc="' + key +'"]').forEach(function(item){
                        item.attributes.href.nodeValue=response.data.meta.files[key].url
                    })
                });
                if(status == 'published'){
                    this.pageContent = element.innerHTML
                }else{
                    this.pageDraftContent = element.innerHTML
                }
            } catch (e) {
                this.alertValue = true
                this.alertType = 'error';
                this.alertMsg =  i18n.t('serverError');
            }
        },
        async changeTemporaryURLsAudio(nodes, element, status){
            var listNodes = []
            for(var i = 0; i < nodes.length; i++){
                if(listNodes.indexOf(nodes[i].attributes.pathAudio.nodeValue) === -1) {
                    listNodes.push(nodes[i].attributes.pathAudio.nodeValue);
                }
            }
            try {
                let data = {
                    data: {
                        type: "activity-pages", 
                        id: this.pageId,
                        attributes: {
                            paths: listNodes.filter((x, i, a) => a.indexOf(x) == i),
                            space_id: this.spaceId
                        }
                    }
                };
                const response = await changeDocumentInActivityPage(this.pageId, data)
                Object.keys(response.data.meta.files).forEach(function(key) {
                    //find and change in html
                    element.querySelectorAll('[pathAudio="' + key +'"]').forEach(function(item){
                        item.attributes.file.nodeValue=response.data.meta.files[key].url
                    })
                });
                if(status == 'published'){
                    this.pageContent = element.innerHTML
                }else{
                    this.pageDraftContent = element.innerHTML
                }
            } catch (e) {
                this.alertValue = true
                this.alertType = 'error';
                this.alertMsg =  i18n.t('serverError');
            }
        },
        getPrevRoute(data){
            if(data.name == 'Activities' || data.name == 'ViewHub' || data.name == 'ViewCategory' || data.name == 'SharedWithMe' ||  data.name == 'Dashboard' || data.name == 'AllActivitiesParticipant' || data.name == 'AllHubsParticipant' ||  data.name == 'ActivitiesParticipant'){
                eventBus.$emit('setActivityExitBtn',data)
            }
        },

        async getActivity(){
            try {
                const response = await getActivity(this.activityId)
                if(response.status == 200) {
                    this.role = response.data.data.attributes.role
                    if (response.data.data.attributes.activity_page_id == null) {
                        this.noPublishedItems = true
                    } else {
                        if (!this.pageExist) {
                            this.$router.push({name: 'PageNotFound'})
                        } else if (this.role != 'booster' && !this.published) {
                            this.$router.push({name: 'PageAccessDenied'})
                        } else if (this.role == 'booster' ||  (this.role != 'booster' && !this.lockedContent)){

                            const response_page = await getActivityPage(this.pageId)
                            if(response_page.status == 200) {
                                this.published = response_page.data.data.attributes.published
                                this.editButtonColor = this.published ? "accent" : "warning"
                                this.editButtonTextColor = this.published ? "white--text" : "black--text"
                                this.checkboxCertificate =response.data.data.attributes.certificate_enabled
                                this.pageContent = response_page.data.data.attributes.content
                                //if no text after <br> tag to add new line
                                if(this.pageContent != null){
                                  this.pageContent = this.pageContent.replace(/<br><\/p>/g, '<br>&nbsp;</p>');
                                }

                                if (this.role == 'participant' || this.role == 'guest') {
                                    await markActivityPageAsStarted(this.pageId)
                                }
                                if(response_page.data.data.relationships.drafts.data.length > 0){
                                    this.draftVersion = true
                                    this.showDraftTag = true
                                    if(this.role == 'booster'){
                                    this.draftVersionId = response_page.data.data.relationships.drafts.data[0].id
                                    const response_draft = await getActivityPageDraft(this.draftVersionId)
                                    if(response_draft.status == 200) {
                                        if(response_draft.data.data.attributes.content != null){
                                            this.pageDraftContent = response_draft.data.data.attributes.content
                                            this.pageDraftContent = this.pageDraftContent.replace(/<br><\/p>/g, '<br>&nbsp;</p>');
                                        }
                                    }
                                    }
                                }     
                                
                             }
                        }
                    }
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        if(this.isAuth){
                            this.$router.push({name: 'PageNotFound'})
                        }else{
                            this.$router.push({name: 'CustomLogin', query: {referer: this.$route.fullPath}})
                        }
                    }else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else if(e.response.status != 401) {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async getActivityPages(){
            try {
                const response = await getActivityPages(this.activityId)
                if (response.status == 200) {
                    if (! response.data.data.find(page => page.attributes.entity_id == this.pageId && page.attributes.entity_type == 'activity_page')) {
                        this.pageExist = false
                    }
                    this.activity_pages = response.data.data.filter(page => page.attributes.is_published == true)
                    if(this.activity_pages.find(page => page.attributes.entity_id == this.pageId && page.attributes.entity_type == 'activity_page')) {
                        this.published = true
                    }
                    var requiredPageId = this.activity_pages.find(page => page.attributes.entity_id == this.pageId && page.attributes.entity_type == 'activity_page').attributes.rule_item_id
                    var requiredPageStatus = this.activity_pages.find(page => page.attributes.entity_id == this.pageId && page.attributes.entity_type == 'activity_page').attributes.rule_fulfilled
                    var requiredDate = this.activity_pages.find(page => page.attributes.entity_id == this.pageId && page.attributes.entity_type == 'activity_page').attributes.rule_available_after

                    if(requiredPageId != null && requiredPageStatus == false){
                        this.lockedContent = true
                        this.requiredContent = this.activity_pages.find(page => page.id == requiredPageId)
                        this.lockType = "feedItemDependent"
                    }else if(requiredDate != null && requiredPageStatus == false){
                        this.lockedContent = true
                        this.requiredContent = { date: moment(requiredDate).format('YYYY-MM-DD') + ' ' + moment(requiredDate).format('HH:mm')}
                        this.lockType = "dateDependent"
                    }
                }
            } catch (e) {
                if(e.response){
                    this.error =  i18n.t('dataNotRetrievedError')
                }
            }
        },
        async checkAndMarkIfFinished () {
            if (this.$route.name != 'ViewActivityPage') {
                window.removeEventListener('scroll', this.checkAndMarkIfFinished)
            } else if ((this.role == 'participant' || this.role == 'guest') && !this.loadingData && !this.scrolledToBottom && !this.lockedContent) {
                let scrollPosition = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight
                let elenemtHight = document.documentElement.offsetHeight - 68
                if (scrollPosition >= elenemtHight) {
                    this.scrolledToBottom = true
                    window.removeEventListener('scroll', this.checkAndMarkIfFinished)
                    try {
                        await markActivityPageAsFinished(this.pageId)
                        //reset navigation
                        if(this.activity_pages.find(item => item.attributes.entity_id == this.pageId && item.attributes.entity_type == 'activity_page').attributes.finished == false){
                            eventBus.$emit('checkUpdates', true, this.checkboxCertificate)
                        }                       
                    } catch (e) {
                        if(e.response){
                            this.alertValue = true
                            if(e.response.status == 404) {
                                this.$router.push({name: 'PageNotFound'})
                            }else if(e.response.status == 403){
                                this.$router.push({name: 'PageAccessDenied'})
                            }else {
                                this.alertType = 'error';
                                this.alertMsg =  i18n.t('serverError');
                            }
                        } 
                    }
                }
            }
        },
    },
}
</script>
<style>
.tab-version {
    box-shadow: 0px 3px 1px -2px rgb(38 50 56 / 10%), 0px 2px 2px 0px rgb(38 50 56 / 10%), 0px 1px 5px 0px rgb(38 50 56 / 10%);
    border: 1px solid var(--v-greytextlight-base);
    background-color: var(--v-greyactivitybackground-base);
    text-transform: capitalize;
}
.greyactivitybackground .v-slide-group__wrapper{
    z-index: 1;
    margin-bottom: -2px;
    padding-right: 40px;
    padding-top: 15px;
}
.tab-version{border-bottom:2px solid #FBC02D}
.tab-version.tab-version-active{border-bottom:2px solid #fff}
.tab-version-active{
    border-right:2px solid #FBC02D;
    border-top:2px solid #FBC02D;
    border-left:2px solid #FBC02D;}
.tab-version-active.publish{
     border: none;
     background-color: #fff;    
}
.tab-version-active.draft{
     background-color: #fff;
     color: #FBC02D;  
}
.tab-version.draft{
    border-bottom: none;

}
</style>